// utils/cloudinaryUpload.js
import axios from "axios";

export const uploadToCloudinary = async (file) => {
    const cloudName = "dxdvcplbl"; // from Cloudinary dashboard
    const preset = "rangpur_golf_country_club"; // from upload settings

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", preset);

    const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
        formData
    );

    return res.data.secure_url; // Cloudinary file URL
};
